import api from './api';

export interface Field {
  id: number;
  name_french: string;
  name_english: string;
  subcategory_id: string;
}

export const fieldsService = {
  async getFields(): Promise<Field[]> {
    try {
      const response = await api.get('/fields');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getFieldsBySubcategory(subcategoryId: string): Promise<Field[]> {
    try {
      const response = await api.get(`/fields/by-subcategory/${subcategoryId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getField(id: number): Promise<Field> {
    try {
      const response = await api.get(`/fields/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default fieldsService;
